import { useEffect, useState } from 'react'
import { Icon } from '../ui/Icon'
import type { StoredVault } from '../transport/relay'
import { faceIdAvailable } from './passkey'

/**
 * True when this device can open `vault` with Face ID / Touch ID: the vault has a passkey
 * door and the device has a platform authenticator (passkey.ts says why the iOS app is not
 * one yet).
 */
export function useFaceId(vault: StoredVault | null | undefined): boolean {
  const [can, setCan] = useState(false)
  const has = !!vault?.pk?.length
  useEffect(() => {
    let live = true
    if (!has) {
      setCan(false)
      return
    }
    void faceIdAvailable().then((ok) => live && setCan(ok))
    return () => {
      live = false
    }
  }, [has])
  return can
}

/** The Face ID door, beside a password field's own submit. */
export function FaceIdButton({ label, disabled, onClick }: { label: string; disabled?: boolean; onClick: () => void }) {
  return (
    <button type="button" className="sheet-btn bk-faceid" disabled={disabled} onClick={onClick}>
      <Icon name="fingerprint" size={18} />
      {label}
    </button>
  )
}
